module.exports = __webpack_public_path__ + "static/media/6_l_plate_0.1_49.81.d2bcca6e.png";